import { z } from 'zod';
import { DeliveryArticleCardModelSchema } from 'entities/delivery-article';
import { GetDeliveryArticlesByCategoryAndTagApiResponseSchema } from '../store';

export const createDeliveryArticleCardsFromGetDeliveryArticlesByCategoryAndTagApiResponse = (
    (response: z.infer< typeof GetDeliveryArticlesByCategoryAndTagApiResponseSchema>) => (
        response.data.map(({
            slug,
            name,
            weight,
            price,
            currency,
            images,

        }) => DeliveryArticleCardModelSchema.parse({
            uid: slug,
            name,
            weight,
            price,
            currency: currency && {
                abbreviation: currency.abbreviation,
            },
            image: images?.[0] && {
                url: images[0].url,
            },
        }))
    )
);
